import React from 'react'

const Dot = ({ cx, index }: { cx: string; index: number }) => (
  <circle cx={cx} cy="6.15" r="2.4" fill="currentColor">
    <animateTransform
      attributeName="transform"
      type="translate"
      values="0 0; 0 -2.25; 0 0;"
      dur="900ms"
      begin={`${120 * index}ms`}
      repeatCount="indefinite"
    />
  </circle>
)

/**
 * Three bouncing dots, inline-sized for use inside buttons/labels (e.g. the
 * Unlock CTA while a purchase is in flight). Mirrors the typing indicator's
 * animation but uses `currentColor` so it adopts the surrounding text color.
 */
const LoadingDots: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    aria-hidden="true"
    className={className}
    viewBox="0 0 20 12.3"
    width="20"
    height="13"
    overflow="visible"
  >
    <Dot cx="3" index={0} />
    <Dot cx="10" index={1} />
    <Dot cx="17" index={2} />
  </svg>
)

export default LoadingDots
